import { baseURL } from "../utils/url";

export const getCustomer = async (clientId) => {
    try {
        const fetchResponse = await fetch(baseURL + `GetCustomerByMerchant?clientId=${clientId}`, {
            method: "GET",
            headers: {

                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};

export const getTransaction = async (clientId) => {
    try {
        const fetchResponse = await fetch(baseURL + `GetTransactionata?clientId=${clientId}`, {
            method: "GET",
            headers: {

                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};
export const transactionView = async (clientId, transactionId) => {
    try {
        const fetchResponse = await fetch(baseURL + `GetTransactionataByTransactionId?clientId=${clientId}&transactionId=${transactionId}`, {
            method: "GET",
            headers: {

                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};

export const getCustomerbyID = async (customerid, merchantId) => {
    try {
        const fetchResponse = await fetch(baseURL + `GetCustomerByCustomerId?customerid=${customerid}&clientId=${merchantId}`, {
            method: "GET",
            headers: {

                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};

export const getAllCustomerbyID = async (clientId, customerid) => {
    try {
        const fetchResponse = await fetch(baseURL + `GetCustomerAllData?clientId=${clientId}&customerid=${customerid}`, {
            method: "GET",
            headers: {

                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};

export const getCampaign = async (mid) => {
    try {
        const fetchResponse = await fetch(baseURL + `GetAllCampaign?mid=${mid}`, {
            method: "GET",
            headers: {

                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};

export const getCampaignbyID = async (code) => {
    try {
        const fetchResponse = await fetch(baseURL + `GetCampaignByCode?code=${code}`, {
            method: "GET",
            headers: {

                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};

export const createCustomer = async (clientId, body) => {
    try {
        const fetchResponse = await fetch(baseURL + `PostCustomer?clientId=${clientId}`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};

export const createTransaction = async (clientId, body) => {
    try {
        const fetchResponse = await fetch(baseURL + `PostTransaction?clientId=${clientId}`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};
export const updateCustomer = async (clientId, body) => {
    try {
        const fetchResponse = await fetch(baseURL + `UpdateCustomer?clientId=${clientId}`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};

export const uploadImage = async (merchantCode, file) => {
    try {
        const formData = new FormData();
        formData.append("file", file);

        const fetchResponse = await fetch(`
https://api.primexloyalty.com/Merchant/upload?merchantCode=${merchantCode}`,
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                },
                body: formData,
            }
        );

        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};

export const createCamapigns = async (body) => {
    try {
        const fetchResponse = await fetch(baseURL + "PostCampaign", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};
export const postRedeem = async ( clientId,customerid,value) => {
    try {
        const fetchResponse = await fetch(baseURL + `PostRedeem?clientId=${clientId}&customerid=${customerid}&value=${value}`, {
            method: "POST",
            headers: {
              
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};

export const updateCamapign = async (body) => {
    try {
        const fetchResponse = await fetch(baseURL + "UpdateCampaign", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};